import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();
    // `vu-safe-bottom` respects the iOS home indicator on installed PWAs.
    return (
        <footer data-testid="app-footer"
                className="mt-12 border-t border-[rgba(26,19,24,0.08)] py-6 px-5 md:px-8 max-w-7xl mx-auto vu-safe-bottom">
            <div className="flex flex-wrap items-center justify-between gap-3 text-xs text-[var(--text-ink)]/55">
                <div>{t("footer.copyright", { year: new Date().getFullYear() })}</div>
                <nav className="flex gap-1 -mx-2">
                    {/* Enlarged touch targets: 44px minimum tap area with
                     * text still visually small. Only the hit-area grows. */}
                    <Link to="/privacy"
                          className="px-3 py-2 rounded-lg hover:text-[var(--brand-purple)] hover:bg-[rgba(26,19,24,0.04)] transition"
                          data-testid="footer-privacy">
                        {t("footer.privacy")}
                    </Link>
                    <Link to="/terms"
                          className="px-3 py-2 rounded-lg hover:text-[var(--brand-purple)] hover:bg-[rgba(26,19,24,0.04)] transition"
                          data-testid="footer-terms">
                        {t("footer.terms")}
                    </Link>
                    <a href="mailto:hello@virtuallyunstoppable.app"
                       className="px-3 py-2 rounded-lg hover:text-[var(--brand-purple)] hover:bg-[rgba(26,19,24,0.04)] transition"
                       data-testid="footer-contact">
                        {t("footer.contact")}
                    </a>
                </nav>
            </div>
        </footer>
    );
}
